import { render, staticRenderFns } from "./pagos.vue?vue&type=template&id=291d8dea&scoped=true"
import script from "./pagos.vue?vue&type=script&lang=js"
export * from "./pagos.vue?vue&type=script&lang=js"
import style0 from "./pagos.vue?vue&type=style&index=0&id=291d8dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291d8dea",
  null
  
)

export default component.exports